module.exports = __webpack_public_path__ + "img/sale.332850b7.jpeg";